// extracted by mini-css-extract-plugin
export default {"reviewPageContainer":"SharePriceTable_reviewPageContainer__SQ9Bt","balanceTable":"SharePriceTable_balanceTable__JjCm1","timerColumn":"SharePriceTable_timerColumn__YRSAG"};